import type { SuggestionContext, SuggestionItem } from '@/chat/types';
import { MusicCard } from '@/music/components/music-card';
import type { GenerationInfo } from '@/music/types';

interface SuggestionResultProps {
  items: SuggestionItem[];
}

export const SuggestionResult = ({ items }: SuggestionResultProps) => (
  <div className="flex w-full flex-col gap-6">
    {items.map((item, index) => (
      <div className="flex flex-col gap-2" key={index}>
        <MusicCard
          music={item.music}
          title={getTitle(item.context)}
          generation={getGenerationInfo(item.context)}
        />
        {(item.context.type === 'recommendation' ||
          item.context.type === 'segment_recommendation') && (
          <p className="text-base">{item.context.explanation}</p>
        )}
      </div>
    ))}
  </div>
);

const getTitle = (context: SuggestionContext): string => {
  switch (context.type) {
    case 'recommendation':
      return '추천 음원';
    case 'segment_recommendation':
      return `${context.segment} 추천 음원`;
    case 'generation':
      return context.segment ? `${context.segment} AI 생성 음원` : 'AI 생성 음원';
  }
};

const getGenerationInfo = (context: SuggestionContext): GenerationInfo | null =>
  context.type === 'generation'
    ? { prompt: context.prompt_used, lyrics: context.lyrics_used }
    : null;
